<template src="./ColissimoModal.html"/>
<style lang='scss' scoped src="./ColissimoModal.scss"/>

<script>
import {
  SfButton,
  SfModal,
  SfScrollable,
  SfCharacteristic,
  SfAccordion,
  SfInput,
  SfSelect
} from '@storefront-ui/vue';
import Api from "@/api/Api";
import {Relais} from "@/models/relais";
import Colissimo from '@/components/Colissimo/Colissimo.vue';
import countries from "@/models/country.json";
import icons from "@/utils/icons";
import OrkLoader from "@/components/Ork/OrkLoader";


let PhoneNumberValidation;
PhoneNumberValidation = require('awesome-phonenumber');
export default {
  name: 'ColissimoModal',
  components: {
    OrkLoader,
    SfButton,
    SfModal,
    SfScrollable,
    SfCharacteristic,
    SfAccordion,
    Colissimo,
    SfInput,
    SfSelect,
  },
  data() {
    return {
      icons: icons,
      countryLang: "label_" + this.$i18n.locale,
      countries: countries,
      countryBlur: true,
      relais: [],
      colissimoId: null,
      loading: true,
      streetBlur: true,
      cityBlur: true,
      postCodeBlur: true,
      validRelaisAddress: false,
      validRelaisPhone: false,
      address: {street: null, city: null, country: null, postCode: null, phone: null},
      userCenter: {lat: 46.50, lng: 2.00},
      userZoom: 13,
      initZoom: 3,
      UserGeocode: null,
      checkColissimoApi: false,
      selectedRelais: null,
      selectedRelaisId: null,
      phoneNumberBlur: false,
      mapReady: false,

    }
  },
  mounted() {

    this.countries.sort((a, b) => {
      return a[this.countryLang] > b[this.countryLang] ? 1 : -1;

    })

    if (window.matchMedia("(max-width: 768px)").matches) {
      let relaisForm = document.getElementById('find-relais-form')
      if (relaisForm) {
        relaisForm.style.display = "none";
      }
    }
  },
  computed: {
    customer: {
      get() {
        return this.$store.getters.getProfile;
      },
    },
    selectedRelaisComp: {
      get() {
        return this.$store.getters.isColissimoModalOpen.selectedRelais
      }
    },
    shipmentWeight: {
      get() {
        return this.$store.getters.isColissimoModalOpen.shipmentWeight
      }
    },
    addressComp: {
      get() {
        return this.$store.getters.isColissimoModalOpen.address
      }
    },
    isColissimoModalOpen: {
      get() {
        return this.$store.getters.isColissimoModalOpen.open
      }
    },
  },
  watch: {
    selectedRelaisComp(newRelais) {
      if (newRelais) {
        //   this.setSelectedRelais(newRelais.name)
        this.selectedRelais = newRelais
        this.selectedRelaisId = newRelais.name
      } else {
        this.selectedRelais = null;
        this.selectedRelaisId = null;
      }
    },
    addressComp(newAddress, oldAddress) {
      if (newAddress && this.address !== newAddress && newAddress !== oldAddress) {
        this.address = {...newAddress};
      }
      if (this.address) {
        this.geocode(this.address)
      }
    },
    UserGeocode(geocode) {
      if (geocode) {
        //    this.reverseGeocode(geocode);
      }
    }
  },

  methods: {
    getMapReady(event) {
      this.mapReady = event;
    },
    toggleAddressForm() {
      let formElement = document.getElementById('find-relais-form')
      if (window.matchMedia("(max-width: 768px)").matches) {
        if (formElement.style.display === "none") {
          formElement.style.display = "block";
        } else {
          formElement.style.display = "none";
        }
      } else {
        formElement.style.display = "flex";
      }
    },
    validCity(city) {
      if (city) {
        return city.length >= 2;
      }

    },
    validStreet(street) {
      if (street) {
        return street.length >= 2;
      }

    },
    validCountry(country) {
      if (country) {
        return country.length > 0 && country === "FR";
      }

    },
    validPostCode(postCode) {
      if (postCode) {
        return postCode.length >= 4;
        //const regex = /^\d+$/;
        // return regex.test(postCode);
      }
    },
    validPhoneNumber(phone) {
      if (phone) {
        let pn;
        let regionCode;
        if (this.address.country) {
          regionCode = this.address.country
          pn = new PhoneNumberValidation(phone, regionCode);
        } else {
          regionCode = new PhoneNumberValidation(phone).getRegionCode();
          pn = new PhoneNumberValidation(phone, regionCode);
        }
        if (pn.isValid()) {
          this.address.phone = pn.getNumber('international');

        }
        this.validRelaisPhone = pn.isValid();
        return pn.isValid();
      }
      return false;
    },
    validateAddress() {
      this.cityBlur = false;
      this.postCodeBlur = false;
      this.streetBlur = false;
      this.countryBlur = false;

      if (
          this.validPostCode(this.address.postCode) &&
          this.validCity(this.address.city) &&
          this.validStreet(this.address.city) &&
          this.validCountry(this.address.country)
      ) {
        this.validRelaisAddress = true;
      } else {
        this.validRelaisAddress = false;
      }
    },


// addressForm
    findRelais() {
      this.validateAddress()
      if (this.validRelaisAddress) {
        this.geocode(this.address)
      }
    },
    getUserGeocode(geocode) {
      this.UserGeocode = geocode
    },
    /*reverseGeocode(geocode) {

      Api.platform.reverseGeocoding(geocode).then((data) => {
        this.address = {...data};
        this.getRelais(data);
      }).catch((e) => {
        console.error(e)
      })
    },*/
    setSelectedRelais(storeId) {
      this.selectedRelaisId = storeId;
      this.selectedRelais = this.relais.find(relais => relais.name === storeId);

    },
    geocode(address) {
      if (address.street && address.postCode && address.country && address.city) {
        this.validateAddress()
        Api.platform.geocode(address).then((data) => {
          this.userCenter = data;
          this.getRelais(address)
        }).catch((e) => {
          console.error(e)
        })
      }
    },

    getRelais(address) {
      if (address.country === 'FR') {
        this.loading = true;
        Api.platform.getApiColissimo({
          address: address,
          weight: this.shipmentWeight
        }).then((data) => {
          this.relais = [];
          let relaisList = data.listePointRetraitAcheminement.filter(relais => relais.typeDePoint === "A2P");

          for (let relais of relaisList) {
            this.relais.push(Relais.of(relais));
          }
          this.colissimoId = data.wsRequestId;
          if (this.$refs.colissimoMap)
              // this.$refs.colissimoMap.updateRelais(this.relais)
            if (this.selectedRelaisId) {
              if (this.$refs.colissimoMap) {
                if (this.relais.find(relais => relais.id === this.selectedRelaisId)) {
                  // this.$refs.colissimoMap.scrollToElementList(this.selectedRelaisId)
                }
              }
            }
          this.loading = false
        }).catch((e) => {

          this.relais = [];
          if (this.$refs.colissimoMap) {
            // this.$refs.colissimoMap.updateRelais(this.relais)
          }
          this.loading = false;
          let error = '';
          switch (e.status) {
            case 500:
              error = this.$i18n.t('errors.server.access')
              this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
              break;
            default:
              this.$store.dispatch('sendNotification', {
                type: 'danger',
                message: this.$i18n.t('errors.server.relaisAddress'),
                icon: this.icons.error
              });
              break;
          }

        })
      } else {
        this.$store.dispatch('sendNotification', {
          type: 'danger',
          message: this.$i18n.t('errors.server.relaisAddress'),
          icon: this.icons.error
        });
      }
    },
    toggleColissimoModal() {
      this.$store.dispatch('toggleColissimoModal', {
        open: false,
        address: this.address,
        selectedRelais: this.selectedRelais
      })
    },

    validStore() {
      this.selectedRelais.phone = this.address.phone;
      this.$store.dispatch('toggleColissimoModal', {
        open: false,
        address: this.address,
        selectedRelais: this.selectedRelais,
      })
    },

    opentTime(item) {
      const openingElements = [...document.getElementsByClassName('isOpenTime')];
      item.target.parentElement.classList.toggle("isOpenTime");
      if (openingElements) {
        openingElements.forEach((element) => {
          if (element !== item.target.parentElement) {
            element.classList.remove('isOpenTime')
          }
        })
      }
    }
  }
};
</script>
